import StatusFilter from './StatusFilter'

const KIND_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'testing', label: 'Testing' },
  { value: 'network-performance', label: 'Network Performance' },
  { value: 'react-rendering', label: 'React Rendering' },
  { value: 'layout-shift', label: 'Layout Shift' },
  { value: 'accessibility', label: 'Accessibility' },
  { value: 'glitches', label: 'Glitches' },
  { value: 'user-experience', label: 'User Experience' },
  { value: 'seo', label: 'SEO' },
]

interface BugKindFilterProps {
  value: string
  onChange: (value: string) => void
}

export default function BugKindFilter({ value, onChange }: BugKindFilterProps) {
  return (
    <StatusFilter
      value={value}
      onChange={onChange}
      options={KIND_OPTIONS}
      label="Kind"
      analyticsPrefix="bug-kind-filter"
      testId="kind-filter"
    />
  )
}
